/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import Button from '../Button';
import CancelReasonsModal from './CancelReasonsModal';
import {
  ABOUT_TO_CLOSE,
  INVALID_PHONE,
  INVALID_ADDRESS,
  VEHICLE_PROBLEM,
} from './cancellation-reasons';

const propTypes = {
  startDelivery: PropTypes.func.isRequired,
  declineOrder: PropTypes.func.isRequired,
  canAcceptOrder: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
};

const defaultProps = {
  isLoading: false,
};

class OrderDetailsActionsNewOrder extends Component {
  handleRef = refName => {
    return ref => {
      this[refName] = ref;
    };
  };

  showModal = () => this.modal.show();

  getReasonList = () => {
    const {
      intl: { formatMessage },
    } = this.props;

    return [
      {
        label: formatMessage({
          id: 'dealer_cancel_modal.dealer_cancel.about_to_close',
          defaultMessage: 'My store is about to close',
        }),
        value: ABOUT_TO_CLOSE,
      },
      {
        label: formatMessage({
          id: 'dealer_cancel_modal.veichle_problem',
          defaultMessage: 'I have problems with my delivery veichle',
        }),
        value: VEHICLE_PROBLEM,
      },
      {
        label: formatMessage({
          id: 'dealer_cancel_modal.invalid_consumer_phone',
          defaultMessage: 'Consumer phone was invalid',
        }),
        value: INVALID_PHONE,
      },
      {
        label: formatMessage({
          id: 'dealer_cancel_modal.invalid_consumer_address',
          defaultMessage: 'Consumer address was invalid',
        }),
        value: INVALID_ADDRESS,
      },
    ];
  };

  onConfirm = (reason, message) => {
    const { declineOrder } = this.props;
    declineOrder(reason, message);
  };

  render() {
    const { startDelivery, isLoading, intl, canAcceptOrder } = this.props;

    return (
      <form onSubmit={startDelivery} className="OrderDetailsLayout__actions_btns">
        <Button type="button" isLoading={isLoading} onClick={this.showModal} variant="secondary">
          <FormattedMessage
            id="orderdetails_step_finalisation_decline"
            defaultMessage="Decline order"
          />
        </Button>
        {canAcceptOrder && (
          <Button
            id="accept-incoming-order-btn"
            type="submit"
            isLoading={isLoading}
            variant="positive"
          >
            <FormattedMessage
              id="orderdetails_step_finalisation_finish"
              defaultMessage="Accept order"
            />
          </Button>
        )}
        <CancelReasonsModal
          isLoading={isLoading}
          handleRef={this.handleRef}
          confirmBtnText={intl.formatMessage({
            id: 'orderdetails_step_finalisation_decline_confirm',
            defaultMessage: 'Decline',
          })}
          reasonList={this.getReasonList()}
          intl={intl}
          onConfirm={this.onConfirm}
        />
      </form>
    );
  }
}

OrderDetailsActionsNewOrder.propTypes = propTypes;
OrderDetailsActionsNewOrder.defaultProps = defaultProps;

export default injectIntl(OrderDetailsActionsNewOrder);



// WEBPACK FOOTER //
// ../ui-components/components/ActionButtons/NewOrder.jsx